export const CURRENCIES = {
  CHF: 'CHF',
  EUR: 'EUR'
}

export const SALARY_DEFAULT = {
  CHF: [100000, 115000],
  EUR: [100000, 115000]
}

export const MAX_SALARY = {
  CHF: 500000,
  EUR: 500000
}

export const SALARY_STEP = {
  CHF: 1000,
  EUR: 1000
}

export const SALARY_FROM_VARIANTS = {
  CHF: [
    20000,
    45000,
    60000,
    80000,
    100000
  ],
  EUR: [
    20000,
    45000,
    60000,
    80000,
    100000
  ]
}
